import { api } from './client';
import type { PresencePeer } from '../types';

export function heartbeat(
  batchId: string | null,
  field: string | null,
): Promise<{ ok: true; at: number }> {
  return api('/api/presence', {
    method: 'POST',
    body: JSON.stringify({ batch_id: batchId, field }),
  });
}

export function listPeers(): Promise<{
  me: string;
  peers: PresencePeer[];
  active_window_ms: number;
}> {
  return api('/api/presence');
}
